exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".login {\n  min-width: 300px;\n  max-width: 500px;\n  margin: 20px auto; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader/lib/loader.js!./styles/login.scss
// module id = 555
// module chunks = 0